/**
 * Conversion tracker
 * Website conversion tracking with postbacks. Supports multiple partners.
 * @see http://docs.airpush.com/index.php?title=S2SConversion
 */
define('components/conversion-tracker',[
    'jquery',
    'logging',
    'utilities',
    'storage'
], function($, logging, utilities, storage) {
    'use strict';
    
    var _ModuleName = "Conversion Tracker";

    var _config = {
        debug: false,
        partners: [
            {
                partner: "airpush", 
                apiURL: "https://api.airpush.com/track/",
                data: [
                    {url_opt: "click_id", api_opt: "guid"}
                ],
                clickData: {},
                enabled: true
            },
            {
                partner: "test", 
                apiURL: "https://api.airpush.com/track/",
                data: [ 
                    // Array of click data objects. Add more objects for extra data. The value of url_opt is
                    // the var name found in the URL and api_opt is the var expected by the API.
                    {url_opt: "one_id", api_opt: "one_guid"},
                    {url_opt: "two_id", api_opt: "two_guid"}
                ],
                clickData: {}, // Data sent to the partner's API
                enabled: false
            }
        ],
        storage: {
            prepend: "convtrk-"
        }
    }

    // Selected partners
    var _selectedPartners = [];

    // URL vars
    var _get = {};

    /**
     * Init function is run imediatly, so DOM is not necessarily available.
     * This can be used for getting things ready such as config storage and such
     * @param {object} data Configuration object with data parameters passed in
     */
    var init = function(data) {

        //Enable console debugging
        logging.init(_config.debug);

        //Get and set the URL vars 
        _setUrlVars();

        // Set the selected partners and their click data
        if (_config.partners instanceof Array && _config.partners.length) {

            // Get the partner config settings
            for (var p = 0; p < _config.partners.length; p++) {
                // Check if the partner is enabled
                if (_config.partners[p].enabled == true) {
                    // Get and set the click data for the selected partners
                    for (var d = 0; d < _config.partners[p].data.length; d++) {
                        // If we found a URL param associated with the partner, store it.
                        if (_get[_config.partners[p].data[d].url_opt]) {
                            _config.partners[p].clickData[_config.partners[p].data[d].api_opt] = _get[_config.partners[p].data[d].url_opt];
                        }
                    }
                    _selectedPartners.push(_config.partners[p]);
                }
            }

            logging.debug(JSON.stringify(_selectedPartners), _ModuleName);
        }

        // Execute the API for each partner based on the click data
        if (_selectedPartners instanceof Array && _selectedPartners.length) {
            for (var i = 0; i < _selectedPartners.length; i++) {
                // Execute the post back if it found click data
                if (!jQuery.isEmptyObject(_selectedPartners[i].clickData) && !data.signup) {
                    logging.debug("Executing postback to " + _selectedPartners[i].partner, _ModuleName);
                    _callApi(_selectedPartners[i].apiURL, _selectedPartners[i].clickData);
                }
            }
        }
    }

    /**
     * Run function on only run after the DOM is ready
     * This can be used for any DOM manipulation code that needs to run
     */
    var run = function() {}

    /**
     * Get variables from the URL and local storage
     */
    var _setUrlVars = function() {
        
        var getStored = storage.getLocalStorage(_config.storage.prepend + "get");
        if (jQuery.isEmptyObject(getStored))
            getStored = {};
        
        location.search.replace(/\??(?:([^=]+)=([^&]*)&?)/g, function () {
            function decode(s) {
                return decodeURIComponent(s.split("+").join(" "));
            }        
            _get[decode(arguments[1])] = decode(arguments[2]);            
        });

        //**************
        storage.setLocalStorage(_config.storage.prepend + "get", Object.assign(getStored, _get));
        
        // Assign stored get vars to local _get.
        if (!jQuery.isEmptyObject(getStored)) {
            for (var prop in getStored) {
                _get[prop] = getStored[prop];
            }
        }

        logging.debug(JSON.stringify(_get), _ModuleName + ' [get vars]');
    }

    /**
     * Make a call to partner API with the click data
     */
    var _callApi = function(apiURL, clickData) {
        var request = $.ajax({
            url: apiURL,
            type: 'GET',
            data: clickData
        });

        request.done(function(data, status, xhr) {
            logging.debug('Postback Success: status: ' + status + '| data: ' + data + '| xhr: ' + JSON.stringify(xhr), _ModuleName);
        });

        request.fail(function(xhr, textStatus) {
            logging.debug('Postback Failed: ' + textStatus + '| xhr: ' + JSON.stringify(xhr), _ModuleName);
        });
    }
    
    return {
        init: init,
        run: run
    }
});
